module.exports = __webpack_public_path__ + "static/undraw_File_bundle_xl7g-df0bb981359985578a0015f4359807e5.svg";